function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#ff5252;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "AWS-Identity-and-Access-Management-IAM_Add-on_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M13.51,37A12,12,0,1,1,24.7,20.65H27l2.58-2.58a1,1,0,0,1,1.41,0l2.58,2.58h1.09l2.58-2.58a1,1,0,0,1,.71-.29h0a1,1,0,0,1,.7.29l2.58,2.58h2.46a1,1,0,0,1,.66.25l3.83,3.35a1,1,0,0,1,.1,1.4L45.39,29a1,1,0,0,1-.76.35H24.7A11.94,11.94,0,0,1,13.51,37Zm0-22A10,10,0,1,0,23,28.05a1,1,0,0,1,1-.7H44.17L46.1,25.1l-2.81-2.45H40.8a1,1,0,0,1-.71-.29l-2.16-2.17-2.17,2.17a1,1,0,0,1-.71.29H33.14a1,1,0,0,1-.71-.29l-2.16-2.17L28.1,22.36a1,1,0,0,1-.71.29H24a1,1,0,0,1-1-.7A10,10,0,0,0,13.51,15ZM10.16,29.35A4.35,4.35,0,1,1,14.51,25,4.35,4.35,0,0,1,10.16,29.35Zm0-6.7A2.35,2.35,0,1,0,12.51,25,2.35,2.35,0,0,0,10.16,22.65Z"
}));

var SvgAwsIamPolicy = function SvgAwsIamPolicy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsIamPolicy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-IAM_Policy.c0db4227.svg";
export { ForwardRef as ReactComponent };